import {Route, Routes} from 'react-router-dom'
import { ToastContainer } from 'react-toastify';
import SHome from './pages/SHome';
import Address from './pages/SHome/Address/address';
import ProductCheck from './pages/SHome/ProductCheck';
import HomeIndex from './pages/SHome/Home';
import Loading from './components/Loading';
import Login from './pages/SHome/Login';
import Register from './pages/SHome/Register';
import Service from './pages/SHome/Service';
import Contact from './pages/SHome/Contact';
import Profile from './pages/SHome/Profile';
import Lesson from './pages/SHome/Lesson';
import LessonSlug from './pages/SHome/Lesson/slug';
import ResetPass from './pages/SHome/ResetPass';
import Belen from './pages/SHome/Products';
import ZahialgaDetail from './pages/SHome/Products/Zahialga/detail';
import BelenDetail from './pages/SHome/Products/Belen/detail';
import CartItem from './pages/SHome/Products/CartItem';
import Checkout from './pages/SHome/Products/Checkout';
import OrderPage from './pages/SHome/Orders';
import UniinMedeelel from './pages/SHome/UniinMedeelel';

function App() {
  return (
    <>
      <ToastContainer/>
      {/* <Navbar/>
      <Alert/> */}
      {/* <Loading/> */}
      <Routes>
        {/* <Route path='/' element={<SHome/>}/> */}
        {/* <Route path='/login' element={<Login/>}/> */}
        {/* <Route path='/' element={<NewHome/>}/>
        <Route path='/profile' element={<NewProfile/>}/>
        <Route path='/register' element={<NewRegister/>}/>
        <Route path='/forgot' element={<Forgot/>}/> */}
        {/* <Route path='/service-procedure' element={<ServiceProcedure/>}/>
        <Route path='/lessons' element={<Lessons/>}/>
        <Route path='/login' element={<Login/>}/>
        <Route path='/register' element={<Register/>}/>
        <Route path='/forget-password' element={<ResetPass/>}/>
        <Route path='/activate/:token' element={<ActivatePage/>}/>
        <Route path='/address' element={<Address/>}/> */}

        <Route path="/" element={<SHome />}>
          <Route index element={<HomeIndex/>}/>
          <Route path="product-check" element={<ProductCheck/>}/>
          <Route path="/address" element={<Address/>}/>
          <Route path="/login" element={<Login/>}/>
          <Route path="/resetpass" element={<ResetPass/>}/>
          <Route path="/register" element={<Register/>}/>
          <Route path="/service" element={<Service/>}/>
          <Route path="/contact" element={<Contact/>}/>
          <Route path="/profile" element={<Profile/>}/>
          <Route path="/lesson" element={<Lesson/>}/>
          <Route path="/une" element={<UniinMedeelel/>}/>
          <Route path="/lesson/:id" element={<LessonSlug/>}/>

          <Route path="/product" element={<Belen/>}/>
          <Route path="/belen/:id" element={<BelenDetail />} />
          <Route path="/zahialga/:id" element={<ZahialgaDetail />} />

          <Route path="/cart-item" element={<CartItem />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/orders" element={<OrderPage />} />
          
          
        </Route> 
        
      </Routes>
      {/* <Footer/> */}
    </>
  );
}

export default App;